module.exports = __webpack_public_path__ + "img/GAME_LINKRIBBON2.710785ac.jpg";